import { dataLocal } from './planeamentoVista';
export const assignmentDay = value => String(value || '').slice(0,10);
export const formatDay = date => `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
export function planningWeek(value = new Date()) {
    const inicio=dataLocal(value); inicio.setDate(inicio.getDate() - (inicio.getDay()+6)%7);
    const fim=new Date(inicio); fim.setDate(fim.getDate()+6); return {inicio,fim};
}
export const overlaps = (a,start,end) => assignmentDay(a.data_inicio)<=end && assignmentDay(a.data_fim)>=start;
export function assignmentPeriod(obra, day) {
    const {inicio,fim}=planningWeek(day), start=assignmentDay(obra.data_inicio), end=assignmentDay(obra.data_fim);
    const data_inicio=start>formatDay(inicio)?start:formatDay(inicio), data_fim=end<formatDay(fim)?end:formatDay(fim);
    return start && end && data_inicio<=data_fim ? {data_inicio,data_fim} : null;
}
const eventName='planning-assignments-changed';
export function publishAssignments() {
    window.dispatchEvent(new Event(eventName));
    try { localStorage.setItem(eventName, `${Date.now()}-${Math.random()}`); } catch (_) { /* Private browser storage may be unavailable. */ }
}
export function watchAssignments(refresh) {
    const visible=()=>{if(document.visibilityState==='visible')refresh();};
    const stored=e=>{if(e.key===eventName)visible();};
    window.addEventListener(eventName,visible); window.addEventListener('focus',visible);
    window.addEventListener('storage',stored); document.addEventListener('visibilitychange',visible);
    const timer=setInterval(visible,30000);
    return ()=>{clearInterval(timer);window.removeEventListener(eventName,visible);window.removeEventListener('focus',visible);window.removeEventListener('storage',stored);document.removeEventListener('visibilitychange',visible);};
}
